<template>
    <page-main>
        <div class="container">
            <div class="page-border">
                <query v-model="query" syear semester keyword="社團名稱、學號、學生姓名">
                </query>
                <btn-group :load="reload" :insert="insert" :del="del" :deleteItems="deleteItem.length" :input="input"></btn-group>
            </div>
            <div class="page-border">
                <table class="table">
                    <thead>
                        <tr>
                            <th style="width:30px;"></th>
                            <th>學年度-學期</th>
                            <th>社團名稱</th>
                            <th>學號-學生名稱</th>
                            <th>職務</th>
                        </tr>
                    </thead>
                    <tr v-for="item in tableData.value" :key="item.CommunityStudentID">
                        <td data-th="選擇"><input type="checkbox" v-model="deleteItem" :value="item.CommunityStudentID" /></td>
                        <td data-th="學年度-學期">{{item.SYear}}-{{item.Semester|semester}}</td>
                        <td data-th="社團名稱">{{item.Name}}</td>
                        <td data-th="學號-學生名稱"><b-button size="sm" variant="link" @click="edit(item.CommunityStudentID)">{{item.StudentNo}}-{{item.StudentName}}</b-button></td>
                        <td data-th="職務">{{item.Job|communityjob}}</td>
                    </tr>
                </table>
                <pagination v-model="pager" :rows="tableData.count" :rowperpage="10" @paging="load"></pagination>
            </div>
        </div>
        <Detail id="info" :modalkey="modalkey" @reload="reload" @edit="edit">
        </Detail>
        <inputmodal id="input" sample="/template/communitystudent.xlsx" url="/api/communitystudent/excel" @ok="reload()"></inputmodal>
    </page-main>
</template>

<script>
    import Detail from './communitystudentDetail.vue';
    import { master } from '@/views';
    export default master({
        name: 'communitystudent',
        api: '/api/communitystudent/',
        components: { Detail },
        data: { communityjobs: [] },
        created: function () {
            window.communityjobs = [];
            this.$parameter.communityjob().then((res) => { window.communityjobs = this.communityjobs = res.data; });
        },
        filters: {
            communityjob: function (value) {
                var temp = value.split(',');
                for (var i = 0; i < temp.length; i++) {
                    let a = window.communityjobs.filter(x => x.key == temp[i]);
                    temp[i] = a.length > 0 ? a[0].value : '';
                }
                return temp.join(',');
            }
        },
    });
</script>

<style>
</style>